import React, { useState, useEffect } from "react";
import axios from "axios";
import ReactTable from "react-table-v6";
import { useParams } from "react-router-dom";
import "../../../assets/css/custom.css";
import { Button, Card, Row, CardBody, Input, Col, Label } from "reactstrap";
import { getApiConfig, API_URL, getUserRoleId } from "../Config/apiConfig";
import customFilterMethod from "helpers/customFilterMethod.js";
const localization = {
  previousText: "Précédent",
  nextText: "Suivant",
  pageText: "Page",
  ofText: "sur",
  rowsText: "lignes",
};
const roleId = getUserRoleId();
const shouldDisplayAlert = (alert) => {
  const alertsVisibility = {
    "Température interne trop élevée": [1, 2, 3, 4, 5],
    "Alerte humidité interne trop élevée": [1, 2, 3, 4, 5],
    "Capteur de vibration": [1, 2, 3, 4, 5],
    "Alerte le boitier a été ouvert par dessus": [1, 2, 3, 4, 5],
    "Alerte le boitier a été ouvert ou est exposé à une lumière trop forte": [1, 2, 3, 4, 5],
    "Perte de connexion du boitier": [1, 2, 3, 4, 5],
    "Le boîtier a redémarré": [1, 2, 3, 4, 5],
    "Bobine débranchée": [1, 2, 3, 4, 5],
    "Données entrantes": [1, 2, 3, 4, 5],
    "Retour de connexion": [1, 2, 3, 4, 5],
    "Nouveau boitier a été créé": [1, 2, 3, 4, 5],
    "Intervention réalisée": [1, 2, 3, 4, 5],
    "Changement d’information dans la base (position, client)": [1, 2, 3, 4, 5]
  };

  return alertsVisibility[alert.title]?.includes(parseInt(roleId)) ?? true;
};

const getAlertColorClass = (title) => {
  const colorClassMap = {
    "Température interne trop élevée": "circle_form_orange",
    "Alerte humidité interne trop élevée": "circle_form_orange",
    "Capteur de vibration": "circle_form_orange",
    "Alerte le boitier a été ouvert par dessus": "circle_form_red",
    "Alerte le boitier a été ouvert ou est exposé à une lumière trop forte": "circle_form_red",
    "Perte de connexion du boitier": "circle_form_orange",
    "Le boîtier a redémarré": "circle_form_blue",
    "Bobine débranchée": "circle_form_orange",
    "Données entrantes": "circle_form_blue",
    "Retour de connexion": "circle_form_blue",
    "Nouveau boitier a été créé": "circle_form_green",
    "Intervention réalisée": "circle_form_green",
    "Changement d’information dans la base (position, client)": "circle_form_green"
  };

  return colorClassMap[title] || "circle_form_red";
};

export default function TabAlert() {
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [boitierAlert, setBoitierAlert] = useState([]);

  // Nouveaux états pour les filtres
  const [filterName, setFilterName] = useState("");
  const [filterDate, setFilterDate] = useState("");
  const [filterColor, setFilterColor] = useState("");

  useEffect(() => {
    axios
      .get(`${API_URL}everyAlertByBoitier/${params.id}`, getApiConfig())
      .then((res) => {
        setBoitierAlert(res.data);
      })
      .catch((err) => {
        console.error(err);
      });
  }, [params.id]);

  const handleDownload = () => {
    setLoading(true);
    axios
      .get(`${API_URL}exportAlertLog/${params.id}`, {
        ...getApiConfig(),
        responseType: "blob",
      })
      .then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "data.csv");
        document.body.appendChild(link);
        link.click();
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  };

  // Application des filtres
  const filteredAlerts = boitierAlert
    .filter((alert) => shouldDisplayAlert(alert, roleId))
    .filter((alert) =>
      filterName
        ? alert.title.toLowerCase().includes(filterName.toLowerCase())
        : true
    )
    .filter((alert) =>
      filterDate
        ? alert.datetime && alert.datetime.startsWith(filterDate)
        : true
    )
    .filter((alert) =>
      filterColor
        ? getAlertColorClass(alert.title) === filterColor
        : true
    );

  const columns = [
    {
      Header: () => <div style={{ textAlign: "center" }}>Couleur Alert</div>,
      accessor: (d) => (
        <div className={getAlertColorClass(d.title)} style={{ width: "20px", minWidth:"20px", minHeight:"20px", height: "20px", borderRadius: "50%" }} />
      ),
    },
    {
      Header: () => <div style={{ textAlign: "center" }}>ALERTE</div>,
      accessor: (d) => {
        return d.unite === "Booléen" ? (
          <div>{d.title}</div>
        ) : (
          <div>
            {d.title}: {d.value} {d.unite}
          </div>
        );
      },
    },
    {
      Header: () => <div style={{ textAlign: "center" }}>DATE</div>,
      accessor: (d) => d.datetime,
    },
  ].map((col, i) => {
    col.id = `${i}`;
    return col;
  });

  return (
    <>
      <Row className="mb-3">
        <Col md={3}>
          <Label for="filterName" className="h5 py-2">Filtrer par nom d'alerte</Label>
          <Input
            id="filterName"
            placeholder="Nom de l'alerte"
            value={filterName}
            onChange={e => setFilterName(e.target.value)}
          />
        </Col>
        <Col md={3}>
          <Label for="filterDate" className="h5 py-2">Filtrer par date</Label>
          <Input
            id="filterDate"
            type="date"
            value={filterDate}
            onChange={e => setFilterDate(e.target.value)}
          />
        </Col>
        <Col md={3}>
          <Label for="filterColor" className="h5 py-2">Filtrer par couleur</Label>
          <Input
            id="filterColor"
            type="select"
            value={filterColor}
            onChange={e => setFilterColor(e.target.value)}
          >
            <option value="">Toutes</option>
            <option value="circle_form_red">Rouge</option>
            <option value="circle_form_orange">Orange</option>
            <option value="circle_form_blue">Bleu</option>
            <option value="circle_form_green">Vert</option>
          </Input>
        </Col>
      </Row>
      <Row className="CenterAll">
        <Card className="mt-5">
          <Card>
            <CardBody>
              {filteredAlerts.length > 0 ? (
                <ReactTable
                  defaultFilterMethod={customFilterMethod}
                  data={filteredAlerts}
                  columns={columns}
                  defaultPageSize={10}
                  previousText={localization.previousText}
                  nextText={localization.nextText}
                  pageText={localization.pageText}
                  ofText={localization.ofText}
                  rowsText={localization.rowsText}
                />
              ) : (
                <div>Aucune donnée disponible</div>
              )}
            </CardBody>
          </Card>
        </Card>
        <Button
          className="float-right"
          color="primary"
          disabled={loading}
          onClick={handleDownload}
        >
          {loading ? "Téléchargement..." : "Exporter Les Données"}
        </Button>
      </Row>
    </>
  );
}
